import styled from "styled-components";

export const NotSignedInDiv = styled.div`
  // background-color: lightgrey;
  padding: 2.5% 0% 2.5% 0%;
  font-weight: bold;
  font-family: Montserrat;
`;
export const SignedInDiv = styled.div`
  // background-color: lightgrey;
  padding: 2.5% 0% 2.5% 0%;
  font-weight: bold;
  font-family: Montserrat;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const UserHeader = styled.h1`
  font-size: 2rem;
  padding: 0% 0% 0.5% 0%;
  text-align: center;
`;
export const UserText = styled.p`
  font-size: 1.6rem;
`;
export const UserName = styled.big`
  font-size: 1.8rem;
  font-weight: bold;
  color: #eb5e52;
`;
export const UserTypeText = styled.big`
  font-size: 1.8rem;
  font-weight: bold;
  color: #eb5e52;
`;
